<template>
<div>
    <div class="header">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center d-flex justify-content-between align-items-center">
                    <div class="logo">
                        <img class="img-fluid" src="@/assets/img/logo_header.png" alt="Girona FC">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <img class="img-fluid d-block d-sm-none" src="@/assets/img/Slide_Principal_Escut.jpg" alt="Girona FC">
    <img class="img-fluid d-none d-sm-block" src="@/assets/img/Slide_Principal_Escut_desk2.jpg" alt="Girona FC">

    <div id="welcome" class="container my-5">
        <div class="row">
            <div class="col-md-12">
                <p class="font-weight-bold text-center">Amb el norantè aniversari del Girona FC, el Club vol reflectir el passat i la visió de futur. Per això, ha proposat una renovació del seu escut per adaptar-lo als temps actuals, reforçar la identitat i per primera vegada els Socis blanc-i-vermells tindran veu en aquest procés.</p>
                <p class="text-center">En primer lloc, els Socis trobareu en aquesta pàgina tota la informació històrica sobre l’escut que us ajudarà de cara a la consulta d’aquest estiu. Les respostes dels Socis a la consulta serviran de base per a dissenyar el nou escut de l’entitat.</p>
            </div>
            <div class="col-md-12">
                <div class="my-5">
                    <img class="img-fluid" src="@/assets/img/Banner_Escut.jpg" alt="">
                </div>
            </div>
            <div class="col-md-6">
                <video loop="true" muted autoplay playsinline class="w-100">
                    <source src="@/assets/primer_escudo_v2.mp4" type="video/mp4">
                    <source src="movie.ogg" type="video/ogg">
                    Your browser does not support the video tag.
                </video>
            </div>
            <div class="col-md-6">
                <h3 class="pre-title title-border-left">L’ORIGEN DE L’ESCUT</h3>
                <p>L’escut original del Girona FC data de l’1 d’Agost de 1930, el dia en que l’Ajuntament de Girona va permetre al Girona Futbol Club, que s’havia fundat pocs dies abans, fer servir l’emblema de la ciutat dins de l’escut del Club.</p>
                <p>És a les hores quan el Girona pren <span class="font-weight-bold">l’escut de la ciutat com a eix central</span> del seu escut original.</p>
                <p><i class="fas fa-check-circle" style="color: #CD1733; margin-right: 3px;"></i>L'emblema de la ciutat estava format per una senyera en forma de rombe; al centre, unes onades blanc-i-vermelles en forma d’escut; i a dalt, la corona ducal que utilitzava la ciutat al 1930.</p>
                <p><i class="fas fa-check-circle" style="color: #CD1733; margin-right: 3px;"></i> El Club va afegir una forma circular, amb llistes vermelles i blanques, en diagonal, que simbolitzen els colors que utilitzaria el Girona FC a la seva samarreta i una doble bordura circular on apareix el nom del club escrit en lletres negres sobre fons blanc.</p>
            </div>
        </div>
    </div>

    <div class="evolucio">
        <div class="container">
            <div class="text-center">
                <h3 class="pre-title">EVOLUCIÓ DE L’ESCUT</h3>
                <p class="text-max-800">L’escut original es va mantenir, pràcticament inalterat, des de l’any 1930 fins a inicis dels anys 2000. Al 2005, amb motiu del 75è aniversari, el Club va realitzar canvis substancials en el disseny, molts dels quals s’apliquen a l’escut actual. Els canvis més significatius al llarg dels anys són els següents:</p>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div id="evolucio-slider">
                        <div class="item">
                            <img src="@/assets/img/ESCUT_1930.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">1930 - FUNDACIONAL</div>
                            <p class="desc">L'escut del Club es forma amb la base de l'escut de la ciutat on s'afegeix una bordura blanca amb llistes blanc-i-vermelles que representen els colors que vestiria l'equip. </p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_1940.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">1940</div>
                            <p class="desc">A partir de la dictadura franquista, i com a conseqüència de la reglamentació que prohibeix els noms en català o d’origen estranger, es castellanitza el nom del club a “GERONA CLUB de FUTBOL”.</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_1970.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">1970</div>
                            <p class="desc">En anys posteriors, una petita variació sobre la corona, que deixa de banda l’ombrejat negre que li donava volum i passa a ser, aquest ombrejat, de color groc. Es redueix el tamany de la lletra del nom del club.</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_1980.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">1980</div>
                            <p class="desc">Ja en democràcia, als anys 80, torna la nomenclatura original i es recupera l’ombrejat negre de la corona, la qual, amb petits canvis, es manté igual.</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_2008.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">2005</div>
                            <p class="desc">El canvi més destacat en els 90 anys d’història. La bordura passa a ser vermella i el perfilat més gruixut. La corona es simplifica i es separa de l’escut de la ciutat, passant a timbrar l’escut del club. S’inclina i disminueix el nombre de llistes blanc-i-vermelles alhora que es redueix el nom del club, un 50% més petit respecte l’escut original.</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_2012.jpg" style="width:100%;height:100%;" alt="">
                            <div class="title">2012</div>
                            <p class="desc">El color de les aigües torna a ser vermell i blanc.</p>
                        </div>
                        <div class="item">
                            <img src="@/assets/img/ESCUT_ACTUAL_v2.png" style="width:100%;height:100%;" alt="">
                            <div class="title">2015 - Actual</div>
                            <p class="desc">El color de la corona passa a ser daurat i s’estilitza el nom del club.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="elements">
        <div class="container">
            <div class="text-center">
                <h3 class="pre-title">ELS ELEMENTS DE L’ESCUT ACTUAL</h3>
                <p class="text-max-800">Descobreix el significat dels elements que formen l’escut del Girona FC fent clic sobre cada element.</p>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <elements-component></elements-component>
                </div>
            </div>
        </div>
    </div>

    <div class="motius">
        <div class="container">
            <div class="text-center mt-3">
                <h3 class="pre-title border-none" style="color: #ffffff; padding: 0 !important;">UNA MIRADA HISTÒRICA DE L'ESCUT</h3>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div id="motius-slider">
                        <div style="width: 100%; display: inline-block; padding: 24px; text-align: center; color: #ffffff;">
                            <img src="@/assets/img/5.jpg" style="max-width: 100%; height: auto; margin: auto;" alt="">
                            <p class="text-max-800" style="margin-top: 25px;">Carnet de Jugador de la temporada 1960-61 d’Albert Gali on apareix l’escut amb el nom en castellà i Club de Futbol enlloc de Futbol Club.</p>
                        </div>
                        <div style="width: 100%; display: inline-block; padding: 24px; text-align: center; color: #ffffff;">
                            <img src="@/assets/img/2.jpg" style="max-width: 100%; height: auto; margin: auto;" alt="">
                            <p class="text-max-800" style="margin-top: 25px;">Samarreta de joc dels anys 70 amb l’escut brodat a mà.</p>
                        </div>
                        <div style="width: 100%; display: inline-block; padding: 24px; text-align: center; color: #ffffff;">
                            <img src="@/assets/img/6.jpg" style="max-width: 100%; height: auto; margin: auto;" alt="">
                            <p class="text-max-800" style="margin-top: 25px;">Marcador de l’estadi de Vistalegre amb l’escut amb la nomenclatura en castellà però Futbol Club enlloc de Club de Futbol.</p>
                        </div>
                        <div style="width: 100%; display: inline-block; padding: 24px; text-align: center; color: #ffffff;">
                            <img src="@/assets/img/3.jpg" style="max-width: 100%; height: auto; margin: auto;" alt="">
                            <p class="text-max-800" style="margin-top: 25px;">Aficionats amb pancartes per animar al Girona FC on han dibuixat o estampat l’escut amb dissenys diferents.</p>
                        </div>
                        <div style="width: 100%; display: inline-block; padding: 24px; text-align: center; color: #ffffff;">
                            <img src="@/assets/img/4.jpg" style="max-width: 100%; height: auto; margin: auto;" alt="">
                            <p class="text-max-800" style="margin-top: 25px;">Marcador de Montilivi, amb el nom orginial, Girona FC i un escut molt similar al fundacional.</p>
                        </div>
                        <div style="width: 100%; display: inline-block; padding: 24px; text-align: center; color: #ffffff;">
                            <img src="@/assets/img/1.jpg" style="max-width: 100%; height: auto; margin: auto;" alt="">
                            <p class="text-max-800" style="margin-top: 25px;">Samarreta del 75è aniversari on l’escut canvia el seu disseny, els canvis més significatius son la incorporació del color vermell com a predominant i la separació de la corona de l’escut de la ciutat.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="proces">
        <div class="container">
            <div class="text-center">
                <h3 class="pre-title">EL PROCÉS CONSULTIU</h3>
            </div>
            <div class="row">
                <div class="col-md-12 my-5 text-center">
                    <h5 class="mb-4" style="color: #cd1733;">LA VEU DELS SOCIS </h5>
                    <p><span class="font-weight-bold">Per primera vegada, els Socis formaran part activa del procés d’evolució de l’escut.</span> </p>
                    <p>Aquest estiu s’habilitarà un <span class="font-weight-bold">procés consultiu exclusiu per a Socis</span> on s'avaluarà quins dels elements de l’escut actual representen millor al club i se’ls oferirà la possibilitat de donar el seu punt de vista sobre l’escut.</p>
                    <p>La informació extreta de la consulta servirà com a guia per a dissenyar el nou escut. Seran doncs els Socis els qui marcaran les bases del futur escut, aconseguint així un escut més proper, autèntic i més vinculat a la terra i a l’afició. </p>
                </div>
                <div class="col-md-12 mt-2 mb-5 text-center">
                    <h5 class="mb-4" style="color: #cd1733;">EL FUTUR ESCUT</h5>
                    <p>El Club vol fer una revisió de l’escut actual mirant els escuts del passat i projectant <span class="font-weight-bold">un disseny modern i actual que reforci la identitat sense perdre l’essència blanc-i-vermella.</span></p>
                    <p>Un dels principals objectius és <span class="font-weight-bold">potenciar la paraula GIRONA</span>, que representa al club, la ciutat i la província de Girona, i que durant els anys ha perdut protagonisme i llegibilitat donat que la seva mida s’ha vist reduida en les darreres actualitzacions de l’escut. </p>
                    <p>El futur escut del club començarà a utilitzar-se oficialment a partir de la temporada 2022/23. </p>
                </div>
                <div class="col-md-12 mt-4">
                    <div class="item">
                        <span class="number">1</span>
                        <h4 class="title text-uppercase">Consulta als Socis</h4>
                        <p>Estiu 2021</p>
                    </div>
                    <div class="item">
                        <span class="number">2</span>
                        <h4 class="title text-uppercase">Presentació escut</h4>
                        <p>Tardor 2021</p>
                    </div>
                    <div class="item">
                        <span class="number">3</span>
                        <h4 class="title text-uppercase">Inici utilització escut</h4>
                        <p>Temporada 2022/23</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="partners" style="background-color: #1b1e21">
        <div class="container">
            <div class="row">
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://gosbi.com/" target="_blank">
                            <img src="@/assets/img/partners/gosbi_white.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://eu.puma.com/es/es/home" target="_blank">
                            <img src="@/assets/img/partners/Logo_Puma.png" class="img-fluid" style="width: 100px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://es.costabrava.org/" target="_blank">
                            <img src="@/assets/img/partners/Logo_CostaBrava.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 text-center">
                        <a href="https://www.factorenergia.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Factorenergia.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                </div>
                <div class="col-md-12 my-2 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.estrelladamm.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_EstrellaDamm.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.caixabank.es/particular/home/particulares_es.html" target="_blank">
                            <img src="@/assets/img/partners/Logo_Caixabank.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 text-center">
                        <a href="https://www.nissan.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Nissan.png" class="img-fluid" style="width: 150px; margin-left: -46px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 ml-5 text-center">
                        <a href="https://www.medplaya.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_MedPlaya.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_LeoBoek.png" class="img-fluid" style="width: 170px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.viajeselcorteingles.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_ECI.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://www.besoccer.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_BeSoccer.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com" target="_blank">
                            <img src="@/assets/img/partners/LeoBoeck_Logo.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>

                    <div class="mt-3 mr-5 text-center">
                        <a href="https://parlem.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Parlem.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <footer>
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-6 p-2 text-center text-lg-left">
                    <ul class="social">
                        <li><a href="https://www.facebook.com/gironafc" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                        <li><a href="https://twitter.com/gironafc" target="_blank"><i class="fab fa-twitter"></i></a></li>
                        <li><a href="https://www.youtube.com/channel/UC6x5gKUZpXuKDujmaHc3Xhg" target="_blank"><i class="fab fa-youtube"></i></a></li>
                        <li><a href="https://www.instagram.com/gironafc/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                    </ul>
                </div>
                <div class="col-12 col-md-6 p-2 text-center text-lg-right">
                    <p>Página Oficial © <a href="https://www.gironafc.cat/" target="_blank">Girona FC</a></p>
                </div>
            </div>
        </div>
    </footer>

</div>
</template>

<script>

require('@/assets/css/app.css')
require('../bootstrap');
import 'slick-carousel/slick/slick';

import ExampleComponent from './ExampleComponent'
import ElementsComponent from './ElementsComponent'
import MotiusComponent from './MotiusComponent'
import EvolucioComponent from './EvolucioComponent'

export default {
    components: {
        ExampleComponent,
        ElementsComponent,
        MotiusComponent,
        EvolucioComponent,
    },
    mounted() {
        window.Popper = require('popper.js').default;
        window.$ = window.jQuery = require('jquery');

        (function ($) {

            "use strict";

            $(document).ready(function () {

                setTimeout(() => {
                    $('#evolucio-slider').slick({
                        centerMode: true,
                        slidesToScroll: 1,
                        centerPadding: '20px',
                        slidesToShow: 3,
                        adaptiveHeight: false,
                        arrows: true,
                        autoplay: true,
                        cssEase: 'linear',
                        prevArrow: '<button class="slick-prev"> < </button>',
                        nextArrow: '<button class="slick-next"> > </button>',
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false,
                                    centerMode: true,
                                    centerPadding: '90px',
                                    slidesToShow: 1
                                }
                            },
                        ]
                    });
                    $('#motius-slider').slick({
                        slidesToShow: 1,
                        autoplay: true,
                        dots: true,
                        arrows: false
                    });
                }, 200);


            });

        })(jQuery);

    },
    methods: {
        isUserFromApp() {
            var url_string = window.location.href
            var url = new URL(url_string);
            var c = url.searchParams.get("fromapp");
            
            return c == 1 ? true : false
        }
    }
}
</script>
